import {startProxyAction} from './actions/start-proxy-action';

export function createStartProxyAction(type) {
  return (props = {}) => dispatch => {
    const promise = new Promise(resolve => {
      dispatch(startProxyAction({type, props, __resolvePromise__: resolve, __correlationId__: Date.now()}));
    });

    return promise;
  };
}
